import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './components/Home/Home';
import Car from './components/Projects/Car/Car';
import GridLoader from "react-spinners/GridLoader";
import { css } from "@emotion/react";
import TeamProject from './components/Projects/TeamProject/TeamProject';
import ProjectsGallery from './components/ProjectsGallery/ProjectsGallery';
import Tarvel from './components/Projects/Tarvel/Tarvel';
import Dental from './components/Projects/Dental/Dental';
import Food from './components/Projects/Food/Food';
import Honda from './components/Projects/Honda/Honda';
import MacBook from './components/Projects/MacBook/MacBook';
import Draggable from './components/Projects/Draggable/Draggable';
import Youtube from './components/Projects/Youtube/Youtube';
import ChatApp from './components/Projects/ChatApp/ChatApp';
import CreativeAgency from './components/Projects/CreativeAgency/CreativeAgency';
import ShodaiMamaHTML from './components/Projects/ShodaiMamaHTML/ShodaiMamaHTML';
import MineCraft from './components/Projects/MineCraft/MineCraft';
import InnovaDecor from './components/Projects/InnovaDecor/InnovaDecor';

const override = css`
  display: block;
  margin: 300px auto;
  border-color: red;
  height: 100vh;
 `;

function App() {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000)
  }, []);
  // #b73361
  return (
    <div className="App">
      {
        loading ?
          <GridLoader style={{ innerHeight: '100vh' }} css={override} color={'rgba(255, 255, 255, 0.689)'} loading={loading} size={15} />
          :
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/projects-gallery" element={<ProjectsGallery />} />
              <Route path="/youtube" element={<Youtube />} />
              <Route path="/chat-app" element={<ChatApp />} />
              <Route path="/team-project" element={<TeamProject />} />
              <Route path="/car-dealer-showroom" element={<Car />} />
              <Route path="/minecraft" element={<MineCraft />} />
              <Route path="/creative-agency" element={<CreativeAgency />} />
              <Route path="/shodaiMama-html" element={<ShodaiMamaHTML />} />
              <Route path="/kode-travel-agency" element={<Tarvel />} />
              <Route path="/dentario-dental-clinic" element={<Dental />} />
              <Route path="/food-delivery-website" element={<Food />} />
              <Route path="/honda-cbr-bootstrap" element={<Honda />} />
              <Route path="/macbook-pro" element={<MacBook />} />
              <Route path="/draggable-card-typescript" element={<Draggable />} />
              <Route path="/innova-decor" element={<InnovaDecor />} />
            </Routes>
          </BrowserRouter>
      }
    </div>
  );
}

export default App;
